import { render, staticRenderFns } from "./DuamList.vue?vue&type=template&id=802011ba&scoped=true&"
import script from "./DuamList.vue?vue&type=script&lang=js&"
export * from "./DuamList.vue?vue&type=script&lang=js&"
import style0 from "./DuamList.vue?vue&type=style&index=0&id=802011ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802011ba",
  null
  
)

export default component.exports